/**
 * Poll wallet-bank EFT status until terminal or timeout.
 */
import { apiService, type WalletBankPaymentStatus } from '../services/apiService';

const DEFAULT_INTERVAL_MS = 5000;
const DEFAULT_MAX_ATTEMPTS = 24;

function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function pollEftPaymentStatus(
  paymentId: string,
  options: { intervalMs?: number; maxAttempts?: number } = {}
): Promise<WalletBankPaymentStatus> {
  const intervalMs = options.intervalMs ?? DEFAULT_INTERVAL_MS;
  const maxAttempts = options.maxAttempts ?? DEFAULT_MAX_ATTEMPTS;
  let last: WalletBankPaymentStatus | null = null;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    last = await apiService.getWalletBankPaymentStatus(paymentId);
    if (last.terminal) {
      return last;
    }
    if (attempt < maxAttempts - 1) {
      await sleep(intervalMs);
    }
  }

  return last!;
}

export function eftStatusModalCopy(status: WalletBankPaymentStatus): {
  title: string;
  message: string;
  type: 'error' | 'warning' | 'info';
} {
  if (status.customerCopy) {
    return {
      title: status.customerCopy.title,
      message: status.customerCopy.message,
      type: status.customerCopy.type,
    };
  }
  if (status.status === 'completed') {
    return {
      title: 'Payment sent',
      message: 'Your EFT has been processed successfully.',
      type: 'info',
    };
  }
  return {
    title: 'Payment submitted',
    message: 'Your EFT is still being processed. Check your transaction history for updates.',
    type: 'info',
  };
}
